import React, { useId, useRef, useState } from "react";
import InlineAttachmentStatus from "./InlineAttachmentStatus";

const ACCEPTED_FILE_TYPES = ".pdf,.jpg,.jpeg,.png,.msg";

const VehicleAttachmentPanel = ({
  apiBase,
  attachmentType,
  multiple = false,
  pendingFiles,
  uploadedFiles,
  canEdit,
  canDeleteSavedAttachments = canEdit,
  isSaving,
  deletingFileId,
  onQueueFiles,
  onRemovePendingFile,
  onDeleteSavedAttachment,
}) => {
  const inputId = useId();
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const disabled = !canEdit || isSaving;

  const queueFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length || disabled) return;
    onQueueFiles(multiple ? files : files.slice(0, 1), attachmentType);
  };

  const openPicker = () => {
    if (!disabled) inputRef.current?.click();
  };

  return (
    <>
      <div
        className={`custom-task-upload-zone d-flex flex-column align-items-center justify-content-center border rounded bg-light text-center p-4 w-100${
          isDragging ? " is-dragging" : ""
        }${disabled ? " opacity-75" : ""}`}
        style={{ minHeight: 145, borderStyle: "dashed", cursor: disabled ? "not-allowed" : "pointer" }}
        onClick={openPicker}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openPicker();
          }
        }}
        onDragOver={(event) => {
          event.preventDefault();
          if (!disabled) {
            event.dataTransfer.dropEffect = "copy";
            setIsDragging(true);
          }
        }}
        onDragLeave={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) {
            setIsDragging(false);
          }
        }}
        onDrop={(event) => {
          event.preventDefault();
          setIsDragging(false);
          queueFiles(event.dataTransfer.files);
        }}
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        data-testid={`vehicle-upload-zone-${attachmentType}`}
      >
        <input
          id={inputId}
          ref={inputRef}
          type="file"
          hidden
          accept={ACCEPTED_FILE_TYPES}
          multiple={multiple}
          disabled={disabled}
          data-testid={`vehicle-file-input-${attachmentType}`}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => {
            queueFiles(event.target.files);
            event.target.value = "";
          }}
        />
        <span className="fw-semibold mb-1">
          Choose {attachmentType} File{multiple ? "s" : ""}
        </span>
        <small className="text-muted">Drag and drop or click to browse</small>
      </div>

      <InlineAttachmentStatus
        apiBase={apiBase}
        attachmentType={attachmentType}
        pendingFiles={pendingFiles}
        uploadedFiles={uploadedFiles}
        canEdit={canEdit}
        canDeleteSavedAttachments={canDeleteSavedAttachments}
        isSaving={isSaving}
        deletingFileId={deletingFileId}
        onRemovePendingFile={onRemovePendingFile}
        onDeleteSavedAttachment={onDeleteSavedAttachment}
      />
    </>
  );
};

export default VehicleAttachmentPanel;
